import { LocaleEnum } from '../enums';

import { CrudMessages, Dictionary } from '../models';

/* tslint:disable:max-line-length */

const CRUD_MESSAGES_EN: CrudMessages = {
  clearSelection: 'Clear selection',
  actions: {
    create: 'New',
    clone: 'Clone',
    update: 'Edit',
    delete: 'Delete',
    enable: 'Enable',
    disable: 'Disable',
    add: 'Add',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    accept: 'Accept'
  },
  sections: {
    details: 'Details',
    configuration: 'Configuration'
  },
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },
  schedule: {
    from: 'From {date}',
    to: 'To {date}',
    always: 'Always'
  },
  search: 'Search',
  noDataFound: 'No data found',
  pagination: {
    rows: 'rows',
    pages: {
      first: 'First page',
      previous: 'Previous page',
      next: 'Next page',
      last: 'Last page'
    },
    ofTotal: 'of',
    download: {
      action: 'Download',
      currentPage: 'Current page',
      custom: 'Custom',
      startingRow: 'Starting row'
    }
  }
};

const CRUD_MESSAGES_ES: CrudMessages = {
  clearSelection: 'Limpiar selección',
  actions: {
    create: 'Nuevo',
    clone: 'Clonar',
    update: 'Editar',
    delete: 'Eliminar',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    add: 'Añadir',
    save: 'Guardar',
    cancel: 'Cancelar',
    back: 'Atrás',
    accept: 'Aceptar'
  },
  sections: {
    details: 'Detalles',
    configuration: 'Configuración'
  },
  status: {
    enabled: 'Habilitado',
    disabled: 'Deshabilitado'
  },
  schedule: {
    from: 'Desde el {date}',
    to: 'Hasta el {date}',
    always: 'Siempre'
  },
  search: 'Buscar',
  noDataFound: 'Datos no encontrados',
  pagination: {
    rows: 'filas',
    pages: {
      first: 'Primera página',
      previous: 'Página anterior',
      next: 'Siguiente página',
      last: 'Última página'
    },
    ofTotal: 'de',
    download: {
      action: 'Descargar',
      currentPage: 'Página actual',
      custom: 'Personalizada',
      startingRow: 'Fila inicial'
    }
  }
};

/* tslint:enable:max-line-length */

export const CRUD_MESSAGES: Dictionary<{ crud: CrudMessages }> = {
  [LocaleEnum.ENGLISH]: {
    crud: CRUD_MESSAGES_EN
  },
  [LocaleEnum.SPANISH]: {
    crud: CRUD_MESSAGES_ES
  }
};
